module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-our-smiles"
  }, [_c('div', {
    staticClass: "slider-our-smiles__container"
  }, [_c('iframe', {
    staticClass: "slider-our-smiles__slider",
    attrs: {
      "title": "extremesmiles gallery",
      "src": "https://roostergrin.github.io/rg-photo-gallery-blacker/"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31878cea","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-our-smiles/slider-our-smiles.pug
// module id = 639
// module chunks = 1